import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { attachmentWithUrlResourceStruct } from "@/modules/attachment/attachmentResourceStruct";

import { getHandbookResourcePath } from "../resources/handbook/handbookResourceConsts";
import { handbookResourceStruct } from "../resources/handbook/handbookResourceStruct";

export const getHandbookQuery = (
  jsonApi: JsonApiClient,
  { companyId, handbookId }: { companyId: string; handbookId: string }
) => {
  return jsonApi.getOne({
    path: getHandbookResourcePath(companyId, handbookId),
    responseStruct: getHandbookResponseStruct,
  });
};

const getHandbookResponseStruct = createResponseStruct({
  data: handbookResourceStruct,
  included: sup.array(attachmentWithUrlResourceStruct),
});

export type GetHandbookResponse = sup.Infer<typeof getHandbookResponseStruct>;
